function guardChildNodeByType(type) {
  return (it) => {
    return "tagName" in it && typeof it.tagName === "string" && it.tagName.toLowerCase() === type.toLowerCase();
  };
}

export { guardChildNodeByType };
//# sourceMappingURL=util.guard-element-type.js.map
